import React, { useState, useRef } from "react";
import { Steps, Button } from "antd";
import { signUpFormFields } from './SignupFormFields';
import FormComponent from "../component/common/FormComponent";

const { Step } = Steps;

const SignUpStepForm = ({ industryTypes, handleSubmit }) => {
  const [current, setCurrent] = useState(0);
  const [formValues, setFormValues] = useState({});
  const formRef = useRef(); // Create form ref

  const formFields = signUpFormFields(industryTypes);

  const next = async () => {
    try {
      const currentValues = await formRef.current.validateAndReturnValues();
      setFormValues(prev => ({ ...prev, ...currentValues }));
      setCurrent(current + 1);
    } catch (err) {
      // Validation error - do not advance step
      console.log("Validation failed:", err);
    }
  };

  const prev = () => setCurrent(current - 1);

  const handleFinalSubmit = async () => {
    try {
      const currentValues = await formRef.current.validateAndReturnValues();
      const allValues = { ...formValues, ...currentValues };
      await handleSubmit(allValues);
    } catch (err) {
      console.log("Final validation failed:", err);
    }
  };

  return (
    <div>
      <Steps current={current} className="custom-steps">
        <Step title="Step 1" />
        <Step title="Step 2" />
        <Step title="Step 3" />
      </Steps>

      <div className="steps-content">
        {current === 0 && (
          <FormComponent
            ref={formRef}
            title={<h1 className="form-title" style={{ color: "rgb(87, 91, 97)" }}>Personal Information</h1>}
            formItems={formFields.slice(0, 4)}
            layout="vertical"
            defaultValues={formValues}
          />
        )}
        {current === 1 && (
          <FormComponent
            ref={formRef}
            title={<h1 className="form-title" style={{ color: "rgb(87, 91, 97)" }}>Company Information</h1>}
            formItems={formFields.slice(4, 7)}
            layout="vertical"
            defaultValues={formValues}
          />
        )}
        {current === 2 && (
          <FormComponent
            ref={formRef}
            title={<h1 className="form-title" style={{ color: "rgb(87, 91, 97)" }}>Confirmation</h1>}
            formItems={formFields.slice(7)}
            layout="vertical"
            defaultValues={formValues}
          />
        )}
      </div>

      <div
  className="steps-action"
  style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',       
    marginTop: '24px'  
  }}
>
  {current > 0 && (
    <Button onClick={prev} className="custom-prev-btn">
      Previous
    </Button>
  )}
  {current < 2 && (
    <Button type="primary" onClick={next}>
      Next
    </Button>
  )}
  {current === 2 && (
    <Button type="primary" onClick={handleFinalSubmit}>
      Submit
    </Button>
  )}
</div>

    </div>
  );
};

export default SignUpStepForm;